import { gsap } from 'gsap'
import { query, _query } from '../utils/query.js'

export function showLoadingModal () {
  try {
    window.modalIsOpen = false
    // this.loadingModal = document.querySelector('#Loading--Modal')
    const openFromVars = {
      opacity: 0,
      display: 'none'
    }
    const openToVars = {
      opacity: 1,
      display: 'block',
      delay: 0,
      duration: 0.5,
      onStart: loadingModalAnimStart.bind(this),
      onComplete: loadingModalAnimComplete.bind(this)
    }
    if (!window.modalIsOpen) {
      document.body.classList.add('Body--IsLoading')
      window.scrollTo(0, 0)
      gsap.fromTo('#Loading--Modal', openFromVars, openToVars)
    }

  } catch (e) {
    console.info(`showLoadingModal error: ${e}`)
  }

}

export function loadingModalAnimStart () {
  window.modalIsOpen = true
  document.querySelector('#Loading--Modal').classList.remove('is-active')
  console.info(`loadingModalAnimStart`)
}

export function loadingModalAnimComplete () {
  //window.modalIsOpen = false
  document.querySelector('#Loading--Modal').classList.add('is-active')
  //this.loadingModal.classList.remove('is-active')
  console.info(`loadingModalAnimComplete`)

}

export async function hideLoadingModal () {
  try {
    // this.loadingModal = document.querySelector('#Loading--Modal')
    const closeFromVars = {
      opacity: 1,
      display: 'block'
    }
    const closeToVars = {
      opacity: 0,
      display: 'none',
      delay: 0,
      duration: 0.5,
      onStart: hideModalAnimStart.bind(this),
      onComplete: hideModalAnimComplete.bind(this)
    }

    document.body.classList.remove('Body--IsLoading')
    gsap.fromTo('#Loading--Modal', closeFromVars, closeToVars)

  } catch (e) {
    console.info(`showLoadingModal error: ${e}`)
  }
}
export function hideModalAnimStart () {
  //window.modalIsOpen = true
  // this.loadingModal.classList.remove('is-active')
  console.info(`hideModalAnimStart`)
}

export function hideModalAnimComplete () {
  window.modalIsOpen = false
  document.querySelector('#Loading--Modal').classList.remove('is-active')
  //this.loadingModal.classList.remove('is-active')
  console.info(`hideModalAnimComplete`)

}
export function triggerTransition () {
  const triggerBtns = query('.barba-transition')
  if (triggerBtns !== null) {
    triggerBtns.forEach((el, index, array) => {
      el.addEventListener('click', () => {
        showLoadingModal()
      })
    })
  }
}

window.showLoadingModal = showLoadingModal
window.hideLoadingModal = hideLoadingModal
